const Loader = () => (
  <div className="flex h-full items-center justify-center p-12">
    <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary border-t-transparent" />
  </div>
);

export default Loader;
